// @flow

import PersistenceRegistry from '../../../react/features/base/redux/PersistenceRegistry';
import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import {
    NAVIGATION_FEATURE_TUTORIAL,
    NAVIGATION_FULL_TUTORIAL
} from '../../modules/Tutorial/constants';

import { UPDATE_STORE_TUTORIAL } from './actionTypes';

export const DEFAULT_STATE = {
    [NAVIGATION_FEATURE_TUTORIAL]: {
        currentStep: null,
        isAllStepsWereShow: false,
        currentTutorial: NAVIGATION_FEATURE_TUTORIAL,
        maxCountSteps: null,
        dateNow: null
    },
    [NAVIGATION_FULL_TUTORIAL]: {
        currentStep: 0,
        isAllStepsWereShow: false,
        currentTutorial: NAVIGATION_FULL_TUTORIAL,
        maxCountSteps: null,
        dateNow: null
    },
    listNewFeatures: [],
    visible: false,
    versionFeature: null
};

/**
 * The redux subtree of this feature.
 */
const STORE_NAME = 'wildix/features/tutorial';

/**
 * Sets up the persistence of the feature {@code tutorial}.
 */
PersistenceRegistry.register(STORE_NAME);

ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case UPDATE_STORE_TUTORIAL:
        return {
            ...state,
            ...action.payload
        };
    default:
        return state;
    }
});
